import React from 'react'
import defaultClasses from './ookaTogetherImage.module.scss'
import { string } from 'prop-types'
import { getFastlyUrl } from '@corratech/pylot-image'
import { useTranslation } from 'next-i18next'

const OokaTogetherImage = (props) => {
    const { image, imageQuality } = props
    const { t } = useTranslation('common')

    return (
        <div className={defaultClasses['ooka-together-image']}>
            {image ? (
                <img
                    src={getFastlyUrl({
                        src: image,
                        quality: imageQuality
                    })}
                    alt={t('OOKA image come together')}
                    loading="lazy"
                />
            ) : (
                ''
            )}
        </div>
    )
}

OokaTogetherImage.propTypes = {
    image: string
}

export default OokaTogetherImage
